import { GIFT_GUIDE_VIEW } from '../actions/types';

const VALUE_NOT_SET = '(not set)';

export const giftGuideGaActionEvents = {
  [GIFT_GUIDE_VIEW]: () => (
    {
      category: 'MHP Gift Guide Module',
      action: 'View module (after scroll)',
      label: VALUE_NOT_SET,
      value: 1,
    }
  ),
};

export const giftGuideClickAndHoverEvents = [
  {
    selector: '.mn_giftGuide .mn_giftGuideButton',
    click: {
      category: 'MHP Gift Guide Module',
      action: 'Shop the gift guide CTA click',
    },
    label: VALUE_NOT_SET,
    value: 1,
  },
  {
    selector: '.mn_giftGuide .mn_offerOverlayLink',
    click: {
      category: 'MHP Gift Guide Module',
      action: 'Merchant tile click to open overlay',
    },
    label: (element) => {
      const { merchantName, merchantId } = element.dataset;

      return `${merchantName} | ${merchantId}`;
    },
    value: 1,
  },
];
